import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISolicitudRevocacion, RespuestaRevocacionFEDTO } from '../../shared/interfaces/database/firma_electronica';
import { TableLazyLoadEvent } from 'primeng/table';
import { Page, Utils } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class SolicitudRevocacionService {
  private readonly baseUrl = `${environment.apiUrl}/api/firma-electronica/solicitud-revocacion`;

  constructor(private readonly http: HttpClient) { }

  getSolicitudesPendientes(event?: TableLazyLoadEvent): Observable<Page<ISolicitudRevocacion>> {
    let params = Utils.getLazyLoadParams(event ?? {});
    return this.http.get<Page<ISolicitudRevocacion>>(`${this.baseUrl}/pendientes`, { params });
  }

  getSolicitudesFinalizadas(event?: TableLazyLoadEvent): Observable<Page<ISolicitudRevocacion>> {
    let params = Utils.getLazyLoadParams(event ?? {});
    return this.http.get<Page<ISolicitudRevocacion>>(`${this.baseUrl}/finalizadas`, { params });
  }

  getSolicitud(solicitudId: number): Observable<ISolicitudRevocacion> {
    return this.http.get<ISolicitudRevocacion>(`${this.baseUrl}/${solicitudId}`);
  }

  respuestaSolicitud(solicitudId: number, request: RespuestaRevocacionFEDTO): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/respuesta/${solicitudId}`, request);
  }
}
